export const RESOURCE_PERSONAS = ['agent', 'new', 'other'];
